<template>
  <q-layout view="lHh Lpr lFf">
    <LoadingIndicator class="loading absolute-center" />
    <Stepper />
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import Stepper from 'components/Layout/Stepper';
import LoadingIndicator from 'components/LoadingIndicator.vue';

export default {
  name: 'MainLayout',
  components: {
    LoadingIndicator,
    Stepper,
  },
};
</script>
